import { render, staticRenderFns } from "./PriceBox.vue?vue&type=template&id=13806816&scoped=true"
import script from "./PriceBox.vue?vue&type=script&lang=ts"
export * from "./PriceBox.vue?vue&type=script&lang=ts"
import style0 from "./PriceBox.vue?vue&type=style&index=0&id=13806816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13806816",
  null
  
)

export default component.exports